import { render } from "./RedirectLink.vue?vue&type=template&id=c83c417a&scoped=true"
import script from "./RedirectLink.vue?vue&type=script&lang=js"
export * from "./RedirectLink.vue?vue&type=script&lang=js"

import "./RedirectLink.vue?vue&type=style&index=0&id=c83c417a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c83c417a"]])

export default __exports__